import React, { useState, useEffect } from "react";

import DB from "_DatabaseFunctions/directConnect";
import { Button } from "@mui/material";

import ModalComp from "app/Components/Modals/ModalTemplate";

interface GameInfo {
  id: string;
  hostId: string;
  gameName: string;
  minPlayers: number;
  gameSessionId?: string;
}

interface ModalDets {
  open: boolean;
  status: string;
}

interface ManageGameModalProps {
  dets: ModalDets;
  gameInfo: GameInfo;
}

function ManageGameModal({ dets, gameInfo }: ManageGameModalProps) {
  const [open, setShow] = useState<boolean>(false);
  const [modalData, setModalData] = useState<{
    title?: string;
    msg?: string;
    type?: string;
    action?: string;
  }>({});

  const StatusMap: Record<string, { status: string; cb: () => void | Promise<void> }> = {
    startGame: {
      status: "Running",
      async cb() {
        const { sessionId, startedAt } = await DB.startGame(gameInfo.id);
        const { hostId, id, gameName } = gameInfo;

        await DB.startGameSession({
          gameId: id,
          hostId,
          gameName,
          startedAt,
          gameSessionId: sessionId,
        });
        // move players to game
      },
    },
    delayGame: {
      status: "Delayed",
      cb() {},
    },
    endGame: {
      status: "Interest",
      async cb() {
        console.log(`gameInfo`, gameInfo);
        await DB.endGameSession({
          gameId: gameInfo.id,
          gameSessionId: gameInfo.gameSessionId,
        });
        await DB.endGame(gameInfo.id);
      },
    },
  };

  useEffect(() => {
    setShow(dets.open);
    renderModalInfo(dets.status);
  }, [dets]);

  const renderModalInfo = (status: string) => {
    switch (status) {
      case "error":
        setModalData({
          title: "Error Starting Game",
          msg: `You need at least ${gameInfo.minPlayers} to start this game`,
          type: "error",
        });
        break;
      case "startGame":
        setModalData({
          title: "Start Game",
          msg: `Start Game ${gameInfo.gameName}?`,
          type: "info",
          action: "started",
        });
        break;
      case "endGame":
        setModalData({
          title: "End Game",
          msg: `End Game ${gameInfo.gameName}? \n This will delete all pending requests and remove all players from the waitlist and game`,
          type: "info",
          action: "ended",
        });
        break;
      case "delayGame":
        setModalData({
          title: "Delay Game",
          msg: `Delay Game ${gameInfo.gameName}?`,
          type: "info",
          action: "delayed",
        });
        break;
      default:
        console.log("case not handled");
        break;
    }
  };

  const changeGameStatus = () => {
    StatusMap[dets.status].cb();
    const { status } = StatusMap[dets.status];
    DB.changeGameStatus(gameInfo.id, status);
  };

  const modalChildren = () => (
    <div>
      {modalData.type === "info" ? (
        <Button
          variant="success"
          onClick={() => {
            changeGameStatus();
            setModalData({
              type: "success",
              title: "Success",
              msg: `Game ${modalData.action} Successfully`,
            });
          }}
        >
          Confirm
        </Button>
      ) : (
        <span />
      )}

      <Button variant="danger" onClick={() => setShow(false)}>
        Close
      </Button>
    </div>
  );

  return (
    <ModalComp
      title={modalData.title}
      modalType={modalData.type}
      msg={modalData.msg}
      show={open}
      onClose={() => setShow(false)}
      action={modalData.action}
    >
      {modalChildren()}
    </ModalComp>
  );
}

export default ManageGameModal;
